import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ExchangeTos from '../../../../components/publisher/tos/Exchange';
import XmlTos from '../../../../components/publisher/tos/Xml';

class Show extends Component {
  state = {
    key: 1
  }

  handleTabSelect(key) {
    this.setState({ key });
  }

  render() {
    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Terms Of Service</h5>
        </div>
        <div className='ibox-content'>
          <Tabs
            activeKey={this.state.key}
            onSelect={this.handleTabSelect.bind(this)}
            id="controlled-tab"
          >
            <Tab
              eventKey={1}
              title="Exchange"
              className='p-md'
            >
              <ExchangeTos />
            </Tab>
            <Tab
              eventKey={2}
              title="XML"
              className='p-md'
            >
              <XmlTos />
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default Show;
